module.exports = __webpack_public_path__ + "static/media/15.4a8d13e4.jpg";